// src/js/components/Slider.js
var Slider = class {
  constructor(el, sel) {
    this.el = el;
    this.options = JSON.parse(el.getAttribute(sel));
    this.options.mediaQuery = "min";
    if (this.el.getAttribute("data-upsell-slider")) {
      el.style.display = "none";
      this.upsellInit = true;
      this.removedProducts = [];
    }
    this.initSplide();
  }
  async initSplide() {
    const Splide = await import("./chunk--splide.esm-NBVXJ4CS.vbt.js");
    this.Splide = Splide.default;
    this.mainSlider = new this.Splide(this.el, this.options);
    if (this.el.parentNode.querySelector("[data-connected-slider]")) {
      this.initConnectedSlider();
    }
    if (this.options.pagination) {
      this.mainSlider.on("mounted", () => {
        this.el.querySelectorAll(".splide__pagination__page").forEach((page) => {
          page.parentElement.addEventListener("click", () => {
            page.click();
          });
        });
      });
    }
    this.mainSlider.on("mounted move", () => {
      const slides = this.el.querySelectorAll(".splide__slide");
      slides.forEach((slide, index) => {
        const title = slide.querySelector(".slide-title");
        if (title) {
          title.setAttribute(
            "aria-selected",
            index === this.mainSlider.index ? "true" : "false"
          );
        }
      });
    });
    const toggleButton = this.el.querySelector(".splide__toggle");
    if (toggleButton) {
      const isPlaying = this.options.autoplay || false;
      toggleButton.setAttribute("aria-pressed", isPlaying ? "true" : "false");
      toggleButton.addEventListener("click", () => {
        const autoplayEnabled = toggleButton.getAttribute("aria-pressed") === "true";
        toggleButton.setAttribute("aria-pressed", autoplayEnabled ? "false" : "true");
      });
    }
    this.mainSlider.mount();
    if (this.upsellInit) {
      this.initUpsellAddRemove();
    }
    if (this.options.adaptiveHeight) {
      this.mainSlider.on(
        "move resize",
        (newIndex) => this.updateHeight(this.mainSlider, newIndex)
      );
      this.updateHeight(this.mainSlider);
    }
    if (this.options.instantStyleChange) {
      this.mainSlider.on(
        "move",
        (newIndex) => this.instantStyleChange(this.mainSlider, newIndex)
      );
    }
  }
  updateHeight(slider, newIndex) {
    const slide = slider.Components.Slides.getAt(
      typeof newIndex == "number" ? newIndex : slider.index
    ).slide;
    const elTarget = slide.firstElementChild;
    slide.parentElement.parentElement.style.height = elTarget.offsetHeight + "px";
  }
  initConnectedSlider() {
    const connectedEl = this.el.parentNode.querySelector(
      "[data-connected-slider]"
    );
    const connectedOptions = JSON.parse(
      connectedEl.getAttribute("data-connected-slider")
    );
    const mainSliderHeight = this.mainSlider.root.getBoundingClientRect().height;
    if (mainSliderHeight < connectedOptions.sliderHeight) {
      connectedOptions.height = mainSliderHeight;
    } else {
      connectedOptions.height = connectedOptions.sliderHeight;
    }
    connectedOptions.height = connectedOptions.height + "px";
    const connectedSlider = new this.Splide(connectedEl, connectedOptions);
    this.mainSlider.on("move", (newIndex) => {
      connectedSlider.go(newIndex);
      if (connectedEl.hasAttribute("data-is-navigation")) {
        this.instantStyleChange(connectedSlider, newIndex);
      }
    });
    connectedSlider.on("move", (newIndex) => {
      this.mainSlider.go(newIndex);
      if (connectedEl.hasAttribute("data-is-navigation")) {
        this.instantStyleChange(connectedSlider, newIndex);
      }
    });
    if (connectedEl.hasAttribute("data-is-navigation")) {
      connectedSlider.on("click", (Slide) => {
        connectedSlider.go(Slide.index);
      });
    }
    connectedSlider.mount();
  }
  instantStyleChange(slider, newIndex) {
    slider.Components.Slides.forEach((s) => {
      const { slide, index } = s;
      slide.classList.toggle("is-active", index === newIndex);
    });
  }
  async initUpsellAddRemove() {
    let max = this.el.getAttribute("data-max");
    if (max) {
      max = parseInt(max);
    }
    if (this.removedProducts.length) {
      console.log("removedProducts", this.removedProducts);
    }
    const updateSlides = async (disableButtons, productHandles2, removeDisplayProperty) => {
      try {
        const {
          Components: { Slides }
        } = this.mainSlider;
        if (disableButtons) {
          Slides.forEach((slide) => {
            const submitButton = slide.slide.querySelector(
              'form button[type="submit"]'
            );
            if (submitButton)
              submitButton.disabled = true;
          });
        }
        Slides.forEach((slide) => {
          if (productHandles2.includes(
            slide.slide.getAttribute("data-product-handle")
          )) {
            if (!slide.slide.classList.contains("splide__slide--clone")) {
              this.removedProducts.push(slide);
            }
            if (!slide.slide.classList.contains("splide__slide--non-removal")) {
              this.mainSlider.remove(slide.index);
            }
          }
        });
        this.removedProducts.forEach((product, i) => {
          if (!productHandles2.includes(
            product.slide.getAttribute("data-product-handle")
          )) {
            this.removedProducts = this.removedProducts.filter(
              (_, index) => index !== i
            );
            this.mainSlider.add(product.slide);
          }
        });
        if (max) {
          ((...args) => args.map(
            (a) => document.querySelector("[data-free-samples]").classList.toggle(a, this.removedProducts.length >= max)
          ))("opacity-1");
        }
        if (disableButtons) {
          Slides.forEach((slide) => {
            const submitButton = slide.slide.querySelector(
              'form button[type="submit"]'
            );
            if (submitButton)
              submitButton.removeAttribute("disabled");
          });
        }
        if (removeDisplayProperty) {
          this.el.style.removeProperty("display");
        }
        if (Slides.getLength() === 0) {
          this.el.style.display = "none";
        } else {
          this.el.style.removeProperty("display");
        }
      } catch (err) {
        console.error(err);
      }
    };
    document.addEventListener(
      "ajaxcart refresh",
      (e) => updateSlides(true, e.detail.productHandles)
    );
    const productHandles = document.querySelector("#product_handles").value;
    setTimeout(() => {
      updateSlides(true, productHandles, true);
    }, 500);
  }
};
var Slider_default = Slider;

export {
  Slider_default
};
